import { render } from "./CIIIndextoBaseline.vue?vue&type=template&id=1a74fb6e"
import script from "./CIIIndextoBaseline.vue?vue&type=script&lang=js"
export * from "./CIIIndextoBaseline.vue?vue&type=script&lang=js"

import exportComponent from "C:\\job\\ems-ISO-final\\frontend_ems\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__